// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
import { ErrorsFragmentDoc } from './UpdateUserSettingsMutation';
export type UserManagementMetamaskAuthenticateInput = {
  address: string;
  appDevice?: string | null | undefined;
  appOs?: string | null | undefined;
  appTech?: string | null | undefined;
  bonusCode?: string | null | undefined;
  captcha?: string | null | undefined;
  cid?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  dateOfBirth?: number | null | undefined;
  email?: string | null | undefined;
  friendRef?: string | null | undefined;
  isApp?: boolean | null | undefined;
  language?: string | null | undefined;
  offers?: boolean | null | undefined;
  otp?: string | null | undefined;
  password?: string | null | undefined;
  phone?: string | null | undefined;
  refAff?: string | null | undefined;
  refCode?: string | null | undefined;
  signature: string;
  site: string;
  username?: string | null | undefined;
};

export type MetamaskAuthMutationVariables = Exact<{
  input: Types.UserManagementMetamaskAuthenticateInput;
}>;


export type MetamaskAuthMutation = { userManagementMetamaskAuthenticate: { token: string | undefined, deviceDataToken: string | undefined, sessionId: string | undefined, errors: Array<{ message: string | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined, userManagement: { currentProfile: { _id: string | undefined } | undefined } | undefined } | undefined };


export const MetamaskAuthMutationDocument = gql`
    mutation MetamaskAuthMutation($input: UserManagementMetamaskAuthenticateInput!) {
  userManagementMetamaskAuthenticate(input: $input) {
    token
    deviceDataToken
    errors {
      ...ErrorsFragment
    }
    sessionId
    userManagement {
      currentProfile {
        _id
      }
    }
  }
}
    ${ErrorsFragmentDoc}`;